import React from 'react';

import {getAccessibleOrInaccessibleId} from 'graphql-client/InaccessibleInfo';
import RequestV2SubmissionChip from 'processes/requests_v2/chips/RequestV2SubmissionChip';
import {ChipSize} from 'ui-library/chips/Chip';

import {
  ProcessTaskDetailsRowContent,
  ProcessTaskGql,
  PROCESS_TASK_DETAILS_LABELS,
} from '../ProcessTaskDetailsPageConstants';

export default function getRequestV2SubmissionRowContent(
  processTask: ProcessTaskGql
): ProcessTaskDetailsRowContent | null {
  if (processTask.process.requestV2Submission == null) {
    return null;
  }
  return {
    label: PROCESS_TASK_DETAILS_LABELS.REQUEST_SUBMISSION,
    component: (
      <RequestV2SubmissionChip
        id={getAccessibleOrInaccessibleId(processTask.process.requestV2Submission)}
        size={ChipSize.TABLE_CELL}
      />
    ),
  };
}
